import styled from "styled-components";

export const StyledImageWrapper = styled.div`
    height: 200px;

    img {
        border-radius: 4px;
        object-fit: contain;
    }
`;
